import { render } from "./Transits.vue?vue&type=template&id=ae5decb2&scoped=true"
import script from "./Transits.vue?vue&type=script&lang=js"
export * from "./Transits.vue?vue&type=script&lang=js"

import "./Transits.vue?vue&type=style&index=0&id=ae5decb2&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src2784445594/src/vedicastrochart-vuejs/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ae5decb2"]])

export default __exports__